import { ApiService } from "@/api";

export default {
  ADD_CLIENTS_MASS({ commit }, clients) {
    return ApiService.client.createClientsMass(clients)
      .then((data) => commit("SET_CLIENTS_MASS_CREATE_REPORT", data))
  },
  GET_LIST_CLIENTS({ commit }, payload) {
    return ApiService.client
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => commit("SET_LIST_CLIENTS", data));
  },
  GET_LIST_CLIENTS_APPEND({ commit }, payload) {
    return ApiService.client
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => {
        commit("SET_LIST_CLIENTS_APPEND", data);
        return data;
      });
  },
};
